import { masterSet } from '@masterSetting/masterSet/masterSetting';

export const LAYOUT_TYPE = {
  TOP: 'topType',
  BLOG: 'blogType',
  LEFT: 'leftType',
  MINIHOME: 'minihomeType',
  THREEDAN: 'threedanType',
  UNSET: 'unsetType',
  MEMO: 'memoType',
  GAMEUI: 'gameuiType',
} as const;

export type LAYOUT_TYPE_KEY = keyof typeof LAYOUT_TYPE;
export type LAYOUT_TYPE_VALUE = typeof LAYOUT_TYPE[LAYOUT_TYPE_KEY];

export const LAYOUT_MAP = {
  [LAYOUT_TYPE.TOP]: '상단형',
  [LAYOUT_TYPE.THREEDAN]: '3단형',
  [LAYOUT_TYPE.LEFT]: '한쪽 정렬형',
  [LAYOUT_TYPE.MINIHOME]: '미니홈피형',
  [LAYOUT_TYPE.BLOG]: '블로그형',
  [LAYOUT_TYPE.MEMO]: '미니메모형',
  [LAYOUT_TYPE.GAMEUI]: '게임UI형',
};

// CharacterPanel 전용 확장 타입 (store 포함)
export type CUSTOM_LAYOUT_TYPE_VALUE = LAYOUT_TYPE_VALUE | 'storeType';

export const layoutTypeList = Object.keys(LAYOUT_MAP).map((key) => {
  if (key === LAYOUT_TYPE.GAMEUI && !masterSet.gameUi) return null;


  return {
    key: key,
    value: LAYOUT_MAP[key],
  };
}).filter(Boolean);
